import Rx from 'rxjs';
import { push } from 'react-router-redux';
import { combineEpics } from 'redux-observable';

import * as constAction from 'root/actionConstants';
import * as preciosActions from 'modules/precios/action';
import * as generalActions from 'modules/general/action';
import * as errorActions from 'modules/error/action';
import { request } from 'core/generalFunctions';

const { ajax } = Rx.Observable;

export const getEpic = (action$, store) =>
  action$.ofType(constAction.PRECIO_GET).switchMap((action) =>
    ajax(request(action))
      .map((result) => preciosActions.setState({ lista: result.response }))
      .catch((err) => errorActions.request(err, action))
      .startWith(generalActions.loadingbar_show())
      .finally(() => store.dispatch(generalActions.loadingbar_hide())),
  );

export const getActivosEpic = (action$, store) =>
  action$.ofType(constAction.PRECIO_GET_ACTIVOS).switchMap((action) =>
    ajax(request(action))
      .map(({ response }) => generalActions.seleccionador_setLista('precios', response))
      .catch((err) => errorActions.request(err, action))
      .startWith(generalActions.loadingbar_show())
      .finally(() => store.dispatch(generalActions.loadingbar_hide())),
  );

export const setEpic = (action$, store) =>
  action$
    .ofType(constAction.PRECIO_SET)
    .throttleTime(2000)
    .switchMap((action) =>
      ajax(request(action))
        .map(() => preciosActions.get())
        .concat(Rx.Observable.of(push('/dashboard/precios')))
        .concat(Rx.Observable.of(generalActions.snackbar_show('Precio guardado')))
        .catch((err) => {
          if (err.status == 457 && err.response.error.name == 'PRECIO_CAMBIO_SIN_CONFIRMACION') store.dispatch(preciosActions.setState({ confirmacionRequerida: true }));
          return errorActions.request(err, action);
        })
        .startWith(generalActions.loadingbar_show())
        .finally(() => store.dispatch(generalActions.loadingbar_hide())),
    );

export const deleteEpic = (action$, store) =>
  action$.ofType(constAction.PRECIO_DELETE).switchMap((action) =>
    ajax(request(action))
      .map(() => preciosActions.get())
      .concat(Rx.Observable.of(push('/dashboard/precios')))
      .concat(Rx.Observable.of(generalActions.snackbar_show('Precio eliminado')))
      .catch((err) => errorActions.request(err, action))
      .startWith(generalActions.loadingbar_show())
      .finally(() => store.dispatch(generalActions.loadingbar_hide())),
  );

export const actualizarViajesEpic = (action$, store) =>
  action$
    .ofType(constAction.PRECIO_UPDATE_VIAJES)
    .debounceTime(2000)
    .switchMap((action) =>
      ajax(request(action))
        .map(() => generalActions.snackbar_show('Precio aplicado a viajes'))
        .catch((err) => errorActions.request(err, action))
        .startWith(generalActions.loadingbar_show())
        .finally(() => store.dispatch(generalActions.loadingbar_hide())),
    );

export default combineEpics(getEpic, getActivosEpic, setEpic, deleteEpic, actualizarViajesEpic);



// WEBPACK FOOTER //
// src/modules/precios/epics.js